export { default } from './MultiTextParagraphs'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/MultiText/MultiTextParagraphs/index.js